module.exports = __webpack_public_path__ + "static/media/moke.da309242.jpg";